import { useState } from "react";

export default function PaymentSuccessPopup({ redirectTo = "/" }) {
  const handleAccess = () => {
    // Redirect to the landing page or any page passed via props
    window.location.href = redirectTo;
  };

  return (
    <div className="w-full min-h-screen flex items-center justify-center bg-gradient-to-br from-[#5346ac78] via-[#8a7dff] to-[#b3a9ff] p-4 relative overflow-hidden">
      
      {/* Floating Shapes */}
      <div className="absolute inset-0 -z-10 overflow-hidden">
        <div className="shape-1 absolute bg-[#5d4ccf] opacity-10 w-20 h-20 rounded-full top-[10%] left-[10%] animate-float"></div>
        <div className="shape-2 absolute bg-[#5d4ccf] opacity-10 w-32 h-32 rounded-full bottom-[10%] right-[10%] animate-float2"></div>
      </div>

      {/* Popup */}
      <div className="popup-overlay fixed inset-0 flex items-center justify-center z-50 animate-fadeIn">
        <div className="popup bg-white rounded-2xl p-8 shadow-2xl w-[90%] max-w-md relative animate-slideUp">
          
          {/* Success Icon */}
          <div className="popup-icon w-[90px] h-[90px] bg-[#5d4ccf1a] border-2 border-[#5d4ccf33] text-[#5d4ccf] rounded-full flex items-center justify-center text-4xl mx-auto mb-6">
            <i className="fas fa-check-circle"></i>
          </div>

          {/* Title */}
          <h2 className="text-[#5d4ccf] text-2xl font-bold mb-3 text-center">
            Payment Successful!
          </h2>

          {/* Message */}
          <p className="text-gray-600 text-center mb-6 leading-relaxed">
            Thank you for your purchase. Your payment has been processed
            successfully. You can now access your purchased course(s).
          </p>

          {/* Button */}
          <button
            onClick={handleAccess}
            className="popup-button bg-[#5d4ccf] hover:bg-[#5040be] text-white font-semibold py-3 px-10 rounded-full shadow-lg w-full flex items-center justify-center gap-2 animate-pulse"
          >
            <i className="fas fa-arrow-right"></i> Go to Home Page
          </button>
        </div>
      </div>
    </div>
  );
}
